import { capitalizeFirstLetter } from './utils/dto.string';
import { createZodDto } from './zod';

import { z } from 'zod';

//CREATE EDIT
export const CreateEditFolderSchema = z.object({
  name: z
    .string()
    .min(1)
    .max(200)
    .transform((val) => capitalizeFirstLetter(val.trim())),
  description: z.string().nullable(),
  isAccessibleByOrganization: z.boolean(),
  authorizedUsers: z.number().array().nullable(),
  parentId: z.number().nullable(),
});

const linkFilesDtoSchema = z.object({
  fileIds: z.number().array(),
});

export class CreateEditFolderDto extends createZodDto(CreateEditFolderSchema) {}
export class LinkFilesDto extends createZodDto(linkFilesDtoSchema) {}
